import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import Joi from "joi-browser";
import SubForm from "../../Components/Comman/SubForm";
import {
    getBprmForm,
    getStateCountyCity,
    getDataTypeCodemanager,
    getUpdateStatus,
    allStateCountyCityReceived,
    formUpdated,
    taskFormSaved,
    getTaskFormSavedStatus,
    getSavedFormDocSasUrls
} from "../../app/store/bprmForm";
import {
    useLoadBprmFormQuery,
    useSaveBprmFormMutation,
    useUpdateBprmFormMutation,
} from "../../app/store/bprmFormApiSlice";
import { CircularProgress, Button as MUIButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { getApplication, getApplicationData } from "../../app/store/application";
import { useLoadApplicationQuery } from "../../app/store/applicationApiSlice";
import {
    getExecuteRuleAppData,
    taskDone,
    getTaskDoneStatus,
} from "../store/WorkflowEngine";
import {
    useWorkflowTaskDoneMutation,
    useExecuteBprmFormRuleMutation,
} from "../store/workflowApiSlice";
import Label from "./BprmDynamicControls/Label";
import TextBox from "./BprmDynamicControls/TextBox";
import Dropdown from "./BprmDynamicControls/Dropdown";
import Date from "./BprmDynamicControls/Date";
import Button from "./BprmDynamicControls/Button";
import Multiline from "./BprmDynamicControls/Multiline";
import { getCurrentUser } from "../store/auth";
import { getAlert, getAlertWithOk } from "../../Services/appAlerts";
import Radio from "./BprmDynamicControls/Radio";
import FileUpload from "./BprmDynamicControls/FileUpload";
import geoService, { getAllCountries, getStateList } from "../../Services/geoService";
import CheckBox from "./BprmDynamicControls/CheckBox";
import ViewFile from "./BprmDynamicControls/ViewFile";
import { uploadFileToBlob } from "../../Services/blobUploadService";

export default function WorkflowElement(props) {
    const { wfTask, handleNextTask, appSummary,
        viewType, viewTypeType, codeVerified, updatedStateData,
        wfTaskType, saveBtnProcessStatus,
        setSaveBtnProcessStatus,
        workflowFormData, documentInfo, actionType } = props;

    const stateSchema = {};
    const [stateData, setStateData] = useState({});
    const [stateErrors, setStateErrors] = useState({});
    const [encryptionDecryptions, setEncryptionDecryptions] = useState({});
    const [wfForm, setWfForm] = useState(null);
    const [documents, setDocuments] = useState([]);
    const [aWorkfinityAppEntity, setAworkfinityAppEntity] = useState("");
    const [aWorkfinityApp, setAworkfinityApp] = useState("");
    const [stateCountyCity, setStateCountyCity] = useState([]);
    const [subformDataType, setSubformDataType] = useState([]);
    const [ddTypeCodMngr, setDdTypeCodMngr] = useState([]);
    const frmDDTypes = [];
    const subformItemIndex = 1;
    const [codeIsVerified, setCodeIsVerified] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [btnProcessStatus, setBtnProcessStatus] = useState(saveBtnProcessStatus);
    const [btnUpdateProcess, setBtnUpdateProcess] = useState(false);
    const [isTaskForm, setIsTaskForm] = useState(false);
    const [currentButtonType, setCurrentButtonType] = useState("");
    const [currentButtonMessage, setCurrentButtonMessage] = useState("");
    const [, setIsCountryStateChanged] = useState(true);

    const [allCountryList, SetAllCountryList] = useState([]);
    const [allStateList, setAllStateList] = useState([]);

    const bprmFormSelector = useSelector(getBprmForm);
    const applicationSelector = useSelector(getApplication);

    const appIdToLoad = wfTask?.ciid > 0 ? wfTask.ciid : null;
    const formIdToLoad = wfTask?.formId > 0 ? wfTask.formId : null;

    // RTK Query Hooks
    const { refetch: refetchApplication } = useLoadApplicationQuery(appIdToLoad, { skip: !appIdToLoad });
    const { isFetching: wfFormFetching } = useLoadBprmFormQuery(formIdToLoad, { skip: !formIdToLoad });

    // When a task is completed and the next task loads (same ciid, new wiid),
    // useLoadApplicationQuery serves the CACHED application data, so the new
    // form is populated with stale values. Once the new task's form has
    // finished loading, re-fetch GetApplication to pull the latest saved
    // application data.
    const appRefreshTaskRef = useRef(null);
    useEffect(() => {
        const taskKey = wfTask?.wiid || wfTask?.id || null;
        if (!appIdToLoad || !taskKey || wfFormFetching) return;
        if (appRefreshTaskRef.current === null) {
            // Initial task: the application query itself just fetched fresh data.
            appRefreshTaskRef.current = taskKey;
            return;
        }
        if (appRefreshTaskRef.current !== taskKey) {
            appRefreshTaskRef.current = taskKey;
            refetchApplication();
        }
    }, [wfTask, appIdToLoad, wfFormFetching, refetchApplication]);

    const [saveBprmFormMut] = useSaveBprmFormMutation();
    const [updateBprmFormMut] = useUpdateBprmFormMutation();
    const [workflowTaskDoneMut, { data: workflowTaskDoneData, isSuccess: workflowTaskDoneSuccess, reset: resetWorkflowTaskDone }] = useWorkflowTaskDoneMutation();
    const [executeBprmFormRuleMut] = useExecuteBprmFormRuleMutation();
    const ruleAppDataSelector = useSelector(getExecuteRuleAppData);
    const updateStatusSelector = useSelector(getUpdateStatus);
    const taskDoneStatusSelector = useSelector(getTaskDoneStatus);
    const taskFormSavedStatusSelector = useSelector(getTaskFormSavedStatus);
    const savedFormDocSasUrlsSelector = useSelector(getSavedFormDocSasUrls);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!saveBtnProcessStatus) {
            setBtnProcessStatus(false);
            if (setSaveBtnProcessStatus)
                setSaveBtnProcessStatus(null);
        }
    }, [saveBtnProcessStatus, setSaveBtnProcessStatus]);

    useEffect(() => {
        if (!wfTask)
            setWfForm(null);

        if (viewType) {
            setIsDisabled(true);
            setCodeIsVerified(false);
        }
        else {
            setCodeIsVerified(true);
        }
    }, [wfTask, viewType]);

    useEffect(() => {
        if (codeVerified) setCodeIsVerified(true);
    }, [codeVerified]);

    useEffect(() => {
        console.log("applicationSelector", applicationSelector);
        console.log("workflowFormData", workflowFormData);
        console.log("appSummary", appSummary);
        console.log("updatedStateData", updatedStateData);
        if (updatedStateData && updatedStateData !== "") {
            const obj = getApplicationData(updatedStateData);
            if (obj?.aWorkfinityApp)
                setAworkfinityApp(obj.aWorkfinityApp);
            if (obj?.aWorkfinityAppEntity)
                setAworkfinityAppEntity(obj?.aWorkfinityAppEntity);
            if (obj?.data)
                setStateData(obj.data);
        } else if (applicationSelector.length > 0) {
            const latestApp = applicationSelector[applicationSelector.length - 1];

            const obj = getApplicationData(latestApp.applicationData);

            if (obj?.aWorkfinityApp)
                setAworkfinityApp(obj.aWorkfinityApp);

            if (obj?.aWorkfinityAppEntity)
                setAworkfinityAppEntity(obj?.aWorkfinityAppEntity);

            if (workflowFormData && obj?.data && !appSummary) {
                const newData = { ...obj.data, ...workflowFormData };
                setStateData(newData);
            } else if (obj?.data && !appSummary) {
                setStateData(obj.data);
            }

        } else {
            setAworkfinityApp("");
            setAworkfinityAppEntity("");
            setStateData({});
        }
    }, [applicationSelector, workflowFormData, appSummary, updatedStateData, wfTask]);

    useEffect(() => {
        if (bprmFormSelector.length > 0) {
            if (!bprmFormSelector[0].isEdit && wfTaskType !== "viewForm") setIsDisabled(true);

            setDocuments([]);
            const loadAllCountry = async () => {
                const allCountry = await getAllCountries();
                SetAllCountryList(allCountry);
            }
            loadAllCountry();
            const loadUsState = async () => {
                const allUsState = await getStateList();
                setAllStateList(allUsState);
            }
            loadUsState();
            setWfForm(bprmFormSelector[0]);
        }
    }, [bprmFormSelector, wfTaskType]);

    const dropdownValuesString = useMemo(() => {
        if (!wfForm?.elementJson) return "";
        try {
            const elements = JSON.parse(wfForm.elementJson);
            const values = [];
            elements.forEach((col) => {
                if (col.components) {
                    col.components.forEach((comp) => {
                        if (comp.dataType === "dropDown") {
                            let controleId = "";
                            if (comp.attributeType) {
                                controleId = comp.attributeType.toLowerCase();
                            }
                            if (comp.attributeObject) {
                                controleId += "." + comp.attributeObject;
                            }
                            if (controleId) {
                                values.push(`${controleId}:${stateData[controleId] || ""}`);
                            }
                        }
                    });
                }
            });
            return values.join("|");
        } catch (e) {
            console.error("Error parsing elementJson in dropdownValuesString useMemo", e);
            return "";
        }
    }, [wfForm, stateData]);

    useEffect(() => {
        if (wfForm !== "") {
            const loadStateCounty = async () => {
                const addResult = await getStateCountyCity(wfForm, stateData);
                const presult = await Promise.all(Object.keys(addResult).map(async (x) => {
                    const obj = addResult[x];
                    if (obj) {
                        const nObj = await Promise.all(obj.stateObjects.map(async (s) => {
                            const nX = { ...s }
                            const rs = await geoService.getGeoData(s.id);
                            nX.list = rs;
                            return nX;
                        }));

                        obj.stateObjects = nObj;

                        const cObj = await Promise.all(obj.countyObjects.map(async (s) => {
                            const stList = nObj.filter(x => x.childCompId === s.compId);
                            if (stList.length > 0) {
                                const stObj = stList[0].list.filter(x => x.name === s.name);
                                if (stObj.length > 0) {
                                    const nX = { ...s }
                                    const rs = await geoService.getGeoData(stObj[0].geonameId);
                                    nX.list = rs;
                                    nX.id = stObj[0].geonameId;
                                    return nX;
                                }
                            }
                        }));

                        obj.countyObjects = cObj;

                        const ccObj = await Promise.all(obj.cityObjects.map(async (s) => {
                            const ctList = cObj.filter(x => x.childCompId === s.compId);
                            if (ctList.length > 0) {
                                const stObj = ctList[0].list.filter(x => x.name === s.name);
                                if (stObj.length > 0) {
                                    const nX = { ...s }
                                    const rs = await geoService.getGeoData(stObj[0].geonameId);
                                    nX.list = rs;
                                    nX.id = stObj[0].geonameId;
                                    return nX;
                                }
                            }
                        }));

                        obj.cityObjects = ccObj;
                    }
                    return obj;
                }));

                dispatch(allStateCountyCityReceived(presult));
                const ddResult = await getDataTypeCodemanager(wfForm);
                setDdTypeCodMngr(ddResult.ddTypeCodMngr);
                setSubformDataType(ddResult.subformDataType);
            }
            loadStateCounty();
            setBtnProcessStatus(false);

        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [wfForm, dropdownValuesString, dispatch]);

    useEffect(() => {
        setBtnUpdateProcess(false);
        if (updateStatusSelector && actionType === "upd") {
            getAlert("", "Updated Successfully", "success");
            dispatch(formUpdated(false))
            handleNextTask();
        }
        else if (updateStatusSelector) {
            dispatch(formUpdated(false));
        }
    }, [updateStatusSelector, actionType, dispatch, handleNextTask]);

    useEffect(() => {
        if (taskFormSavedStatusSelector || updateStatusSelector || taskDoneStatusSelector || workflowTaskDoneSuccess) {
            refetchApplication();
        }
    }, [taskFormSavedStatusSelector, updateStatusSelector, taskDoneStatusSelector, workflowTaskDoneSuccess, refetchApplication]);

    // Removed duplicate useEffect that cleared stateData. Combined logic in the main applicationSelector useEffect.

    const handleSubformModalShowHide = useCallback(() => {

    }, []);

    const handleSubformSave = useCallback((aWorkfinityAppEntity, subformId) => {
        //setState({ aWorkfinityAppEntity, ["showHide" + subformId]: false });
    }, []);

    const validateProperty = useCallback(({ name, value }) => {
        if (stateSchema && stateSchema[name]) {
            const obj = { [name]: value };
            const schema = { [name]: stateSchema[name] };
            const { error } = Joi.validate(obj, schema);
            return error ? error.details[0].message : null;
        } else {
            return null;
        }
    }, [stateSchema]);

    const validateDocuments = useCallback((docs) => {
        const errors = { ...stateErrors };
        const data = { ...stateData };
        if (docs.length > 0) {
            data["docs"] = docs.length.toString();
            delete errors["docs"];
        } else {
            const obj = { schedule: "" };
            const schema = { schedule: stateSchema["docs"] };
            const { error } = Joi.validate(obj, schema);
            errors["docs"] = error.details[0].message;
            data["docs"] = "";
        }
        console.log("validateDocuments", errors, data);
        setStateData(data);
        setStateErrors(errors);
    }, [stateData, stateErrors, stateSchema]);

    const handleChange = useCallback((input) => {
        const data = { ...stateData };
        const errors = { ...stateErrors };
        const errorMessage = validateProperty(input);
        if (errorMessage) errors[input.name] = errorMessage;
        else delete errors[input.name];
        data[input.name] = input.value;
        console.log("handleChange", errors, data);
        setStateData(data);
        setStateErrors(errors);
    }, [stateData, stateErrors, validateProperty]);

    const addEncryptionFieldData = useCallback((name, value) => {
        const encryp = { ...encryptionDecryptions };
        const data = { ...stateData }
        const newValue = value.replace(/-/g, "");

        let modifiedValue = "";
        for (let i = 0; i < newValue.length; i++) {
            modifiedValue += "*";
        }
        if (encryp[name + "encrypt"]) {
            data[name] = modifiedValue;
            encryp[name] = encryp[name] + value.replace(/[^\d]/g, "");
        } else {
            data[name] = value.replace(/[^\d]/g, "");
            encryp[name] = modifiedValue;
        }
        setEncryptionDecryptions(encryp);
        console.log("addEncryptionFieldData", encryp, data);
        setStateData(data);
    }, [encryptionDecryptions, stateData]);

    const handeOnChange = useCallback(({ target: input }) => {
        handleChange(input);
        if (input.dataset?.encryption) {
            addEncryptionFieldData(input.name, input.value);
        }
    }, [handleChange, addEncryptionFieldData]);

    const handleEncryptionDecryption = useCallback((name) => {
        const updatedData = { ...stateData };
        const encryp = { ...encryptionDecryptions };
        if (encryp[name + "encrypt"]) {
            const actualValue = encryp[name];
            const encryptedValue = updatedData[name];
            encryp[name] = encryptedValue;
            updatedData[name] = actualValue;
            encryp[name + "encrypt"] = false;
        } else {
            const encryptedValue = encryp[name];
            const actualValue = updatedData[name];
            encryp[name] = actualValue;
            updatedData[name] = encryptedValue;
            encryp[name + "encrypt"] = true;
        }
        setEncryptionDecryptions(encryp);
        console.log("handleEncryptionDecryption", encryp, updatedData);
        setStateData(updatedData);
    }, [stateData, encryptionDecryptions]);

    const onFileChange = useCallback((event) => {
        const docs = [...documents];
        const data = { ...stateData };

        const docIndex = docs.findIndex((x) => x.refId === event.target.name);
        if (docIndex > -1) {
            docs.splice(docIndex, 1);
        }
        let indx = 0;
        if (docs.length > 0) {
            indx = docs[docs.length - 1].id;
        }
        for (const file of event.target.files) {
            indx += 1;
            const ext = file.name.split(".");
            var doc = {
                id: indx,
                name: file.name,
                newName: file.name,
                type: file.type,
                file: file,
                refId: event.target.name,
                extension: ext.length > 1 ? ext[1] : "",
            };
            docs.push(doc);
        }

        data[event.target.name] = event.target.files[0].name;
        validateDocuments(docs);
        setDocuments(docs);
        console.log("onFileChange", docs, data);
        setStateData(data);
    }, [documents, stateData, validateDocuments]);

    const validate = useCallback(() => {
        if (wfTask?.status) return true;

        const options = { abortEarly: false, allowUnknown: true };
        const result = Joi.validate(stateData, stateSchema, options);
        if (!result.error) return null;
        const errors = {};
        for (let item of result.error.details) {
            const reqItem = stateSchema[item.path[0]];
            if (reqItem?._flags?.presence === "required")
                errors[item.path[0]] = item.message;
        }
        if (Object.keys(errors).length === 0) return false;

        return errors;
    }, [wfTask, stateData, stateSchema]);

    const doSubmit = useCallback(async (btn, alMsg) => {
        const btnType = btn.name;
        setCurrentButtonMessage(alMsg);
        setBtnProcessStatus(true);
        setCurrentButtonType(btnType);
        if (wfTaskType === "form") {
            handleNextTask(stateData);
        }
        else {
            const btnType = btn.name;
            Object.keys(stateData).forEach(function (keyValue) {
                const dd = keyValue.split(".");
                if (dd.length > 1) {
                    if (dd[1] !== "undefined" && aWorkfinityAppEntity !== undefined)
                        if (aWorkfinityAppEntity[dd[0].toLowerCase()] !== undefined) {
                            var item = stateData[keyValue];
                            if (Array.isArray(item))
                                aWorkfinityAppEntity[dd[0].toLowerCase()][dd[1]] = item;
                            else aWorkfinityAppEntity[dd[0].toLowerCase()]["@" + dd[1]] = item;
                        }
                }
            });

            const appShortName = Object.keys(aWorkfinityApp)[1];
            aWorkfinityApp[appShortName] = aWorkfinityAppEntity;
            const frmData = new FormData();
            frmData.append("appEntity", JSON.stringify(aWorkfinityApp));
            frmData.append("workItem", JSON.stringify(wfTask));
            frmData.append("upDocs", JSON.stringify(documents));

            frmData.append("files", JSON.stringify(documents.map((file) => {
                return {
                    id: file.id,
                    name: file.name,
                    newName: file.newName,
                    type: file.type,
                    extension: file.extension,
                    refId: file.refId,
                    size: file.size
                }
            })));

            if (documentInfo) {
                frmData.append("docType", documentInfo.docType);
                frmData.append("updType", documentInfo.updType);
                frmData.append("message", documentInfo.message);
            }

            saveBprmFormMut(frmData);

            if (wfTaskType === "viewForm") {
                handleNextTask(frmData);
            }
            else if (btnType !== "save" && btnType !== "saveAndExit" && (wfTask?.wiid > 0 || wfTask?.id > 0)) {
                setIsTaskForm(true);
            }
        }
    }, [wfTaskType, handleNextTask, stateData, aWorkfinityApp, aWorkfinityAppEntity, wfTask, documents, documentInfo, saveBprmFormMut]);

    useEffect(() => {
        if (taskFormSavedStatusSelector && isTaskForm && (wfTask?.wiid > 0 || wfTask?.id > 0)) {
            const taskData = {
                ...wfTask,
                wiid: wfTask.wiid || wfTask.id,
                id: wfTask.id || wfTask.wiid
            };
            workflowTaskDoneMut(taskData);
            setIsTaskForm(false);
            dispatch(taskFormSaved(false));
        }
    }, [taskFormSavedStatusSelector, isTaskForm, wfTask, workflowTaskDoneMut, dispatch]);

    useEffect(() => {
        if (currentButtonMessage === "" || isTaskForm) return;
        if (wfTaskType !== "form" && !taskFormSavedStatusSelector) return;

        if (wfTaskType === "viewForm") {
            // The ViewForm wrapper shows a single success alert and reloads the
            // page data once the form-library history update also completes.
            // Showing another alert here caused the double
            // "Saved Successfully" / "Updated Successfully" popups.
            // Note: taskFormSaved(false) is intentionally NOT dispatched here;
            // ViewForm resets it after both requests have finished.
            setCurrentButtonMessage("");
            setCurrentButtonType("");
            setBtnProcessStatus(false);
            return;
        }

        getAlertWithOk("", currentButtonMessage, "success", () => {
            setTimeout(() => {
                handleNextTask(currentButtonType);
            }, 1000);
        });
        setCurrentButtonMessage("");
        setCurrentButtonType("");
        setBtnProcessStatus(false);
        dispatch(taskFormSaved(false));
    }, [
        currentButtonMessage,
        currentButtonType,
        handleNextTask,
        isTaskForm,
        taskFormSavedStatusSelector,
        wfTaskType,
        dispatch,
    ]);

    const updateBprmFormData = useCallback(async () => {
        setBtnUpdateProcess(true);
        const disValus = _.uniq(frmDDTypes);
        Object.keys(stateData).forEach(function (keyValue) {
            const dd = keyValue.split(".");
            if (dd.length > 1) {
                if (dd[1] !== "undefined" && aWorkfinityAppEntity !== undefined)
                    if (aWorkfinityAppEntity[dd[0].toLowerCase()] !== undefined) {
                        var item = stateData[keyValue];
                        if (Array.isArray(item))
                            aWorkfinityAppEntity[dd[0].toLowerCase()][dd[1]] = item;
                        else aWorkfinityAppEntity[dd[0].toLowerCase()]["@" + dd[1]] = item;
                    }
            }
        });
        const appShortName = Object.keys(aWorkfinityApp)[1];
        aWorkfinityApp[appShortName] = aWorkfinityAppEntity;
        const currentUser = getCurrentUser();
        const frmData = new FormData();
        frmData.append("appEntity", JSON.stringify(aWorkfinityApp));
        frmData.append("ciid", wfTask.ciid);
        frmData.append("ddTypes", disValus);
        frmData.append("formId", wfTask.formId);
        frmData.append("performerId", currentUser.id);
        frmData.append("userName", currentUser.name);

        updateBprmFormMut(frmData);
    }, [frmDDTypes, stateData, aWorkfinityApp, aWorkfinityAppEntity, wfTask, updateBprmFormMut]);

    useEffect(() => {
        console.log("workflowTaskDoneData", workflowTaskDoneData);
        console.log("taskDoneStatusSelector", taskDoneStatusSelector);
        console.log("workflowTaskDoneSuccess", workflowTaskDoneSuccess);
        console.log("currentButtonMessage", currentButtonMessage);
        console.log("currentButtonType", currentButtonType);

        const workflowTaskDoneHasNextTask = workflowTaskDoneData?.id > 0 && 
            workflowTaskDoneData?.id !== wfTask?.wiid && 
            workflowTaskDoneData?.id !== wfTask?.id;
        const workflowTaskDoneHasStatus = workflowTaskDoneData?.status ?? false;
        console.log("workflowTaskDoneHasNextTask", workflowTaskDoneHasNextTask);
        console.log("workflowTaskDoneHasStatus", workflowTaskDoneHasStatus);
        if (!taskDoneStatusSelector && !workflowTaskDoneSuccess && !workflowTaskDoneHasNextTask && !workflowTaskDoneHasStatus) return;

        dispatch(taskDone({ status: false }));
        resetWorkflowTaskDone();

        if (updatedStateData && updatedStateData !== "")
            updateBprmFormData();

        if (currentButtonMessage !== "") {
            getAlert("", currentButtonMessage, "success");
            setCurrentButtonMessage("");
            setCurrentButtonType("");
        }
        setBtnProcessStatus(false);
        if (workflowTaskDoneHasNextTask) {
            handleNextTask(workflowTaskDoneData);
        } else {
            handleNextTask(currentButtonType);
        }
    }, [
        taskDoneStatusSelector,
        workflowTaskDoneSuccess,
        workflowTaskDoneData,
        dispatch,
        resetWorkflowTaskDone,
        updatedStateData,
        updateBprmFormData,
        currentButtonMessage,
        currentButtonType,
        handleNextTask,
    ]);

    useEffect(() => {
        const uploadAllDocuments = async () => {
            if (savedFormDocSasUrlsSelector?.length > 0) {
                try {
                    await Promise.all(
                        documents.map((file, key) =>
                            uploadFileToBlob(
                                file.file,
                                savedFormDocSasUrlsSelector[key]?.uploadUrl,
                                (progress) => {
                                    console.log(`Upload progress: ${progress}%`);
                                }
                            )
                        )
                    );

                    console.log("All files uploaded successfully!");
                } catch (error) {
                    console.error("Upload failed:", error);
                }
            }
        };

        uploadAllDocuments();
    }, [savedFormDocSasUrlsSelector, documents]);

    const getEvaluatedValue = useCallback(async (comp) => {
        const ruleId = comp.rule;
        const data = { ...stateData };
        Object.keys(data).forEach(function (keyValue) {
            const dd = keyValue.split(".");
            if (dd.length > 1) {
                if (dd[1] !== "undefined" && aWorkfinityAppEntity !== undefined)
                    if (aWorkfinityAppEntity[dd[0].toLowerCase()] !== undefined) {
                        var item = data[keyValue];
                        if (Array.isArray(item))
                            aWorkfinityAppEntity[dd[0].toLowerCase()][dd[1]] = item;
                        else aWorkfinityAppEntity[dd[0].toLowerCase()]["@" + dd[1]] = item;
                    }
            }
        });
        const appShortName = Object.keys(aWorkfinityApp)[1];
        aWorkfinityApp[appShortName] = aWorkfinityAppEntity;
        const formData = new FormData();
        formData.append("appEntity", JSON.stringify(aWorkfinityApp));
        formData.append("appId", 1);
        formData.append("ruleId", ruleId);

        executeBprmFormRuleMut(formData);
    }, [stateData, aWorkfinityApp, aWorkfinityAppEntity, executeBprmFormRuleMut]);

    useEffect(() => {
        if (ruleAppDataSelector !== "") {
            const appShortName = Object.keys(ruleAppDataSelector)[1];
            const newAWorkfinityAppEntity = ruleAppDataSelector[appShortName];
            const data = { ...stateData };
            if (newAWorkfinityAppEntity !== "") {
                Object.keys(newAWorkfinityAppEntity).forEach(function (keyValue) {
                    if (
                        keyValue !== "@xmlns:xsd" &&
                        keyValue !== "@xmlns:xsi" &&
                        keyValue !== "EntityId"
                    ) {
                        Object.keys(newAWorkfinityAppEntity[keyValue]).forEach(function (
                            keyValue1
                        ) {
                            if (keyValue1 !== "EntityId") {
                                var item = newAWorkfinityAppEntity[keyValue][keyValue1];
                                if (typeof item === "object") {
                                    if (Array.isArray(item))
                                        data[keyValue + "." + keyValue1.replace("@", "")] = item;
                                    else data[keyValue + "." + keyValue1.replace("@", "")] = [item];
                                } else {
                                    data[keyValue + "." + keyValue1.replace("@", "")] = item;
                                }
                            }
                        });
                    }
                });
            }
            console.log("getEvaluatedValue", data);
            setStateData(data);
        }
    }, [ruleAppDataSelector, stateData]);

    const getSubformTableHeader = (comp) => {
        const tblHd = subformDataType?.filter(
            (x) =>
                x.dataType ===
                comp.attributeType &&
                x.attribute ===
                comp.attributeObject
        );
        if (tblHd.length === 0) return <tr>
            <th>Datatype not found</th>
        </tr>
        return <tr>
            {tblHd[0].itemList.map(item => <th>
                {item.split(".")[1]}
            </th>)}
            {comp.isEdit && <th>Action</th>}
        </tr>
    }

    const getSubformTableBody = (comp) => {
        const dataObj = aWorkfinityAppEntity[comp.attributeType.toLowerCase()][comp.attributeObject];
        if (dataObj && dataObj?.length > 0) {
            return <tr>
                {dataObj.map((obj, key) => {
                    const tblBd = subformDataType?.filter(
                        (x) =>
                            x.dataType ===
                            comp.attributeType &&
                            x.attribute ===
                            comp.attributeObject
                    );

                    if (tblBd.length > 0) {
                        return tblBd[0].itemList.map(item => <td>
                            {obj["@" + item.split(".")[0]]}
                        </td>)
                    }
                    return comp.isEdit && <td>
                        <button
                            className="btn btn-sm btn-outline-default"
                            onClick={() =>
                                handleSubformModalShowHide(
                                    "showHide" +
                                    comp.subform +
                                    "-" +
                                    key
                                )
                            }
                        >
                            Edit
                        </button>
                    </td>
                })}
            </tr>
        }

        return <tr><td>No Data</td></tr>
    }

    const getHighestColNum = (elements) => {
        const col = elements.reduce(function (prev, current) {
            return prev.components.length > current.components.length
                ? prev
                : current;
        });
        return col.components.length;
    }

    const handlePrintPdf = async (event) => {
        // const frmData = new FormData();
        // //console.log(this.refs.printBody.outerHTML);
        // frmData.append("html", this.refs.printBody.outerHTML);
        // const { data } = await http.post(config.PrintTemplate, frmData);
        // let pdfWindow = window.open("");
        // pdfWindow.document.write(
        //   "<iframe width='100%' height='100%' src='" +
        //     data +
        //     "' style='border: none;'></iframe>"
        // );
    };

    let elements = [];
    if (wfForm?.elementJson) {
        try {
            elements = JSON.parse(wfForm.elementJson);
            // console.log(elements)
        } catch (ex) {
            console.log(ex)
            elements = [];
        }
    }

    const compNum = elements.length > 0 && wfTaskType === "template" ? getHighestColNum(elements) : 0;
    return (
        <fieldset disabled={false}>
            {wfTaskType === "template" &&
                <div id="printBody">
                    <div className="table-responsive">
                        <table className="table table-bordered bg-white">
                            {elements.map((col) => (
                                <tr>
                                    {col.components.filter(x => x.dataType !== "button").map((comp) => {
                                        let controleId = "";
                                        if (comp.attributeType)
                                            controleId = comp.attributeType?.toLowerCase();

                                        if (comp.attributeObject)
                                            controleId += "." + comp.attributeObject;

                                        return (
                                            <td
                                                style={{ whiteSpace: "pre-wrap" }}
                                                colSpan={
                                                    col.components.length === 1
                                                        ? compNum
                                                        : compNum - col.components.length
                                                }
                                            >
                                                {/* {this.rendorHtmlComponent(comp)} */}
                                                {comp.dataType === "label" &&
                                                    <Label comp={comp} controleId={controleId} stateData={stateData} />}
                                                {comp.dataType === "textBox" &&
                                                    <TextBox
                                                        comp={comp}
                                                        controleId={controleId}
                                                        stateData={stateData}
                                                        stateErrors={stateErrors}
                                                        stateSchema={stateSchema}
                                                        codeIsVerified={codeIsVerified}
                                                        isDisabled={isDisabled}
                                                        handleChange={handleChange}
                                                        handeOnChange={handeOnChange}
                                                        getEvaluatedValue={getEvaluatedValue}
                                                    />}
                                                {comp.dataType === "multiLineBox" && <Multiline
                                                    comp={comp}
                                                    controleId={controleId}
                                                    stateData={stateData}
                                                    stateErrors={stateErrors}
                                                    isDisabled={isDisabled}
                                                    encryptionDecryptions={encryptionDecryptions}
                                                    handeOnChange={handeOnChange}
                                                    getEvaluatedValue={getEvaluatedValue}
                                                    handleEncryptionDecryption={handleEncryptionDecryption}
                                                />
                                                }
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                        </table>
                    </div>
                </div>}
            {wfTaskType !== "template" &&
                <div className="row">
                    {elements.map((col) => {
                        let showColData = true;
                        if (col.isVisible) {
                            showColData = false;
                            if (col?.visibleAttributeType && col?.visibleAttributeObject) {
                                const vDd = col?.visibleAttributeType.toLowerCase() + "." + col?.visibleAttributeObject;
                                const vRv = col.visibleRuleValue;
                                const vRd = stateData[vDd];
                                const matches = vRv?.split(',')
                                    .map(v => v.trim().toLowerCase())
                                    .includes(vRd?.trim().toLowerCase());
                                if (matches) showColData = true;
                            }
                        }
                        return showColData && <div className={`col-${col.width} ${col?.cssclass ? col.cssclass : ""}`}>
                            {col.components.map((comp, key) => {
                                let controleId = "";
                                if (comp.attributeType)
                                    controleId = comp.attributeType?.toLowerCase();

                                if (comp.attributeObject)
                                    controleId += "." + comp.attributeObject;

                                if (comp.isRequired && controleId !== "" && comp.dataType !== "esign") {
                                    if (comp.label)
                                        stateSchema[controleId] = Joi.string().required().label(comp.label);
                                    else
                                        stateSchema[controleId] = Joi.string().required().label("Field is required");
                                }

                                if (comp.attributeType && frmDDTypes.indexOf(comp.attributeType) === -1) {
                                    frmDDTypes.push(comp.attributeType);
                                }

                                if (comp.dataType === "list") {
                                    const formDD = subformDataType?.filter(
                                        (x) =>
                                            x.dataType ===
                                            comp.attributeType &&
                                            x.attribute ===
                                            comp.attributeObject
                                    );
                                    return (
                                        <React.Fragment>
                                            <SubForm
                                                showHide={stateData["showHide" + comp.subform]}
                                                handleModalShowHide={handleSubformModalShowHide}
                                                title={comp.label}
                                                subFormId={comp.subform}
                                                aWorkfinityAppEntity={aWorkfinityAppEntity}
                                                subFormDataType={comp.attributeType}
                                                subFormAttribute={comp.attributeObject}
                                                handleSubformSave={handleSubformSave}
                                                subformItemIndex={subformItemIndex}
                                                formDD={formDD.length > 0 && formDD[0]}
                                            ></SubForm>
                                            <div className="table-responsive">
                                                <table
                                                    className="table table-bordered"
                                                    id={`table-to-xls-${comp.subform}`}
                                                >
                                                    <thead className="thead-light">
                                                        {getSubformTableHeader(comp)}
                                                    </thead>
                                                    <tbody>
                                                        {getSubformTableBody(comp)}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </React.Fragment>
                                    );
                                } else
                                    if (comp.dataType === "button") {
                                        if (comp.buttonType?.type === "editForm1" || comp.buttonType?.type === "subform") {
                                            return <Button comp={comp}
                                                btnProcessStatus={btnProcessStatus}
                                                isDisabled={isDisabled}
                                                setIsDisabled={setIsDisabled}
                                                isEdit={wfForm?.isEdit}
                                            />
                                        }
                                        return null;
                                    } else {
                                        if (comp.dataType === "label") {
                                            return <Label comp={comp} controleId={controleId} stateData={stateData} />
                                        }
                                        if (comp.dataType === "textBox") {
                                            return <TextBox
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                stateSchema={stateSchema}
                                                codeIsVerified={codeIsVerified}
                                                isDisabled={isDisabled}
                                                viewTypeType={viewTypeType}
                                                handleChange={handleChange}
                                                handeOnChange={handeOnChange}
                                                getEvaluatedValue={getEvaluatedValue}
                                            />
                                        }

                                        if (comp.dataType === "dropDown") {
                                            return <Dropdown
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                codeIsVerified={codeIsVerified}
                                                isDisabled={isDisabled}
                                                stateCountyCity={stateCountyCity}
                                                setStateCountyCity={setStateCountyCity}
                                                ddTypeCodMngr={ddTypeCodMngr}
                                                setDdTypeCodMngr={setDdTypeCodMngr}
                                                handleChange={handleChange}
                                                handeOnChange={handeOnChange}
                                                allStateList={allStateList}
                                                allCountryList={allCountryList}
                                                setIsCountryStateChanged={setIsCountryStateChanged}
                                            />
                                        }

                                        if (comp.dataType === "date") {
                                            return <Date
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                codeIsVerified={codeIsVerified}
                                                isDisabled={isDisabled}
                                                handleChange={handleChange}
                                            />
                                        }

                                        if (comp.dataType === "multiLineBox") {
                                            return <Multiline
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                isDisabled={isDisabled}
                                                encryptionDecryptions={encryptionDecryptions}
                                                handeOnChange={handeOnChange}
                                                getEvaluatedValue={getEvaluatedValue}
                                                handleEncryptionDecryption={handleEncryptionDecryption}
                                            />
                                        }

                                        if (comp.dataType === "radio") {
                                            return <Radio
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                isDisabled={isDisabled}
                                                handeOnChange={handeOnChange}
                                            />
                                        }

                                        if (comp.dataType === "checkBox") {
                                            return <CheckBox
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                isDisabled={isDisabled}
                                                handleChange={handleChange}
                                                ddTypeCodMngr={ddTypeCodMngr}
                                            />
                                        }

                                        if (comp.dataType === "file") {
                                            return <FileUpload
                                                comp={comp}
                                                controleId={controleId}
                                                stateData={stateData}
                                                stateErrors={stateErrors}
                                                isDisabled={isDisabled}
                                                onFileChange={onFileChange}
                                            />
                                        }

                                        if (comp.dataType === "viewFile") {
                                            return <ViewFile controlId={controleId} comp={comp} />
                                        }
                                        return null;
                                    }
                            })}
                        </div>
                    }

                    )}
                    <div className="col-md-12">
                        <div className="card shadow-none border">
                            {actionType === "workflow" &&
                                <div className="card-header text-center bg-lighter p-2">
                                    <h4 className="mb-0 text-dark">
                                        <i
                                            className="fa fa-arrow-right mr-2"
                                            aria-hidden="true"
                                        ></i>
                                        WORKFLOW ACTION
                                    </h4>
                                </div>}
                            <div className="card-body p-3">
                                <div className="row">
                                    {!appSummary &&
                                        <div className="col-md-12 text-center">
                                            {elements.map((col) =>
                                                col.components.filter(x => x.dataType === "button").map((comp) => {
                                                    if (comp.buttonType?.type === "editForm1" || comp.buttonType?.type === "subform") {
                                                        return null;
                                                    }
                                                    if (comp.buttonType?.type) {
                                                        return <Button comp={comp}
                                                            btnProcessStatus={btnProcessStatus}
                                                            //setBtnProcessStatus={setBtnProcessStatus}
                                                            isDisabled={isDisabled}
                                                            setIsDisabled={setIsDisabled}
                                                            validate={validate}
                                                            doSubmit={doSubmit}
                                                            isEdit={wfForm?.isEdit}
                                                            currentButtonType={currentButtonType}
                                                        />;
                                                    }
                                                    return null;
                                                })
                                            )}
                                        </div>
                                    }
                                    {appSummary &&
                                        <div className="col-md-12 text-center">
                                            {/* <button
                                                className="btn btn-sm btn-outline-default"
                                                disabled={viewType || btnUpdateProcess}
                                                onClick={() => updateBprmFormData()}
                                            >
                                                {btnUpdateProcess ? <i className="fa fa-spinner fa-spin mr-1"></i>
                                                    : <i className="fa fa-pencil mr-1" aria-hidden="true"></i>}
                                                Update
                                            </button> */}
                                            <MUIButton
                                                variant="outline"
                                                color="inherit"
                                                size="small"
                                                onClick={() => updateBprmFormData()}
                                                disabled={viewType || btnUpdateProcess}
                                                startIcon={
                                                    btnProcessStatus ? (
                                                        <CircularProgress size={16} color="inherit" />
                                                    ) : (
                                                        <EditIcon />
                                                    )
                                                }
                                                sx={{
                                                    "&.Mui-disabled": {
                                                        backgroundColor: "#9e9e9e",
                                                        color: "#333333",
                                                        opacity: 1,
                                                    },
                                                    mr: 1,
                                                    mb: 1,
                                                    textTransform: "none",
                                                    border: "1px solid #172b4d",
                                                    color: "black",
                                                    "&:hover": {
                                                        backgroundColor: "#172b4d",
                                                        color: "white",
                                                        borderColor: "#172b4d",
                                                    },
                                                }}
                                            >
                                                Update
                                            </MUIButton>

                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}

            {wfTaskType === "template" && <div className="col-md-12 text-center">
                <button className="btn btn-sm btn-outline-default" onClick={handlePrintPdf}>
                    <i className="fa fa-print"></i>  Print
                </button>
            </div>}
        </fieldset>
    )
}
